const isServer = typeof window === 'undefined'
export const getIsMobile = () =>
  isServer ? false : document.documentElement.clientWidth <= 960
